import { AUTH_TOKEN } from "../constants";
import AuthTokenMutation from "../mutations/AuthTokenMutation";
import VerifyTokenMutation from "../mutations/VerifyTokenMutation";

export default {
  login(username, password, _cb) {
    const cb = arguments[arguments.length - 1];
    if (localStorage.token) {
      if (cb) {
        cb(true);
      }
      this.onChange(true);
      return;
    }
    AuthTokenMutation(username, password, (tokenAuth) => {
      if (tokenAuth) {
        localStorage.setItem(AUTH_TOKEN, tokenAuth.token);
        if (cb) {
          cb(true);
        }
        this.onChange(true);
      } else {
        if (cb) {
          cb(false);
        }
        this.onChange(false);
      }
    });
  },

  getToken() {
    return localStorage.getItem(AUTH_TOKEN);
  },

  logout(cb) {
    localStorage.removeItem(AUTH_TOKEN);
    if (cb) {
      cb();
    }
    this.onChange(false);
  },

  verifyToken(cb) {
    const token = this.getToken();
    VerifyTokenMutation(token, (isValid) => {
      if (cb) {
        cb(isValid);
      }
    });
  },

  loggedIn() {
    return !!this.getToken();
  },

  onChange() {},
};



// WEBPACK FOOTER //
// ./src/helpers/auth.js